import script from "./OrganizationContractModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractModal.vue?vue&type=style&index=0&id=415c8844&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415c8844"]])

export default __exports__